module.exports = __webpack_public_path__ + "img/istp-selected.85e7e90c.png";